/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../atoms/Text/Text';
import './ProgressRendererStyles.scss';
const baseClass = 'qmb-ui-ProgressRenderer';
export function ProgressRenderer({ block }) {
    const progress = block;
    const pct = progress.percent_complete;
    return (React.createElement("div", { className: baseClass },
        React.createElement("div", { className: `${baseClass}__header` },
            React.createElement("i", { className: "fa-light fa-spinner-third fa-spin" }),
            React.createElement(Text, { variant: "body" }, progress.message)),
        progress.detail && (React.createElement(Text, { variant: "body", className: `${baseClass}__detail` }, progress.detail)),
        pct !== undefined && (React.createElement("div", { className: `${baseClass}__bar-wrapper` },
            React.createElement("div", { className: `${baseClass}__bar`, style: { width: `${pct}%` } }),
            React.createElement(Text, { variant: "body", className: `${baseClass}__pct` },
                pct,
                "%"))),
        progress.items_total !== undefined && progress.items_processed !== undefined && (React.createElement(Text, { variant: "body", className: `${baseClass}__items` },
            progress.items_processed,
            " / ",
            progress.items_total,
            " items"))));
}
